module.exports = __webpack_public_path__ + "static/media/embedded.df56647f.svg";